export const POST_SALES_CORPORATE = "POST_SALES_CORPORATE";
export const POST_SALES_APARTMENT = "POST_SALES_APARTMENT";
export const CAT_BY_PRODUCT = "CAT_BY_PRODUCT";
export const TAG = "TAG";
export const CONTRACT_APARTMENT = "CONTRACT_APARTMENT";
export const CONTRACT_CORPORATE = "CONTRACT_CORPORATE";
export const CONTRACT_SUPPLY = "CONTRACT_SUPPLY";
export const CLIENT_FOR_FINANCE = "CLIENT_FOR_FINANCE";
export const CAT_BY_BRAND = "CAT_BY_BRAND";
